/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Данные платежа
 */
export type PaymentItem = {
  /**
   * Тип
   */
  type: PaymentItem.type
  /**
   * Сумма платежа
   */
  amount: string
  /**
   * Дата платежа
   */
  date: string
}
export namespace PaymentItem {
  /**
   * Тип
   */
  export enum type {
    INCOME = 'income',
    RETURN = 'return'
  }
}
